export const getDynamicContentSettingsResp = {
  languages: ["en", "ru"],
  industries: [
    {
      name: "aviation",
      customers: ["SG", "VS", "Y4"],
    },
    {
      name: "shipping",
      customers: ["BSM"],
    },
    {
      name: "road",
      customers: [],
    },
  ],
};
